import * as React from 'react'
import { FiDollarSign } from 'react-icons/fi'

export default function() {
  return (
    <FiDollarSign
      style={{ marginRight: '5px', minHeight: '16px', minWidth: '16px' }}
    />
  )
}
